import { differenceInMonths, subMonths, addMonths } from 'date-fns';
export const getDateFromYYYYMMDD = dateString => {
  const [year, month, day] = dateString.split('-');
  return new Date(year, month, day);
};

function range(size, startAt = 0) {
  return [...Array(size).keys()].map(i => i + startAt);
}

export const getDateForEachMonthBetweenDates = (fromString, toString) => {
  const from = getDateFromYYYYMMDD(fromString);
  const to = getDateFromYYYYMMDD(toString);

  const numOfMonts = Math.abs(differenceInMonths(from, to)) + 1;
  return range(numOfMonts).reduce((acc, val, index) => {
    if (acc.length === 0) return [subMonths(from, 1)];
    return acc.concat(addMonths(acc[index - 1], 1));
  }, []);
};

export const parseDate = dateString => {
  //`D/M/YY`
  if (dateString.match(/^[0-9]+\/[0-9]+\/[0-9]+$/)) {
    const [day, month, year] = dateString.split('/');
    return new Date(
      parseInt(20 + year),
      parseInt(month.padStart(2, '0')) - 1,
      parseInt(day.padStart(2, '0'))
    );
  }
  //`YYYY-MM-DD`
  else if (dateString.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
    const [year, month, day] = dateString.split('-');
    let dateToReturn = new Date(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(day)
    );
    return dateToReturn;
  } else {
    console.log("Date in unexpected format: ", dateString);
  }
};
